// extracted by mini-css-extract-plugin
export default {"recipeBtn":"Page_recipeBtn__k8Mz5","centerLoader":"Page_centerLoader__cA3gh","placeholderText":"Page_placeholderText__zPNz4"};